/**
 * What THIS build ships. A screen only one product offers is imported behind `__PRODUCT__`:
 *
 *   lazy(() => (__PRODUCT__ === 'thunder' ? import('…/OverviewView') : notShipped<typeof import('…/OverviewView')>())
 *     .then((m) => ({ default: m.OverviewView })))
 *
 * `__PRODUCT__` is a literal at build time, so the bundler folds the test and drops the branch it
 * cannot take — and the `import()` with it, so the other product's chunk is never emitted. The
 * profile's `hiddenTabs` already keeps the screen from rendering; this keeps it from downloading,
 * and from being in the build at all.
 */

/**
 * The module this build does not ship. Rejected rather than left pending: it cannot be reached
 * through a hidden tab, and if a future route ever reaches it anyway, the error boundary says
 * which screen failed instead of a loader that spins forever.
 */
export function notShipped<M>(): Promise<M> {
  return Promise.reject(new Error(`This screen is not part of ${__PRODUCT__}.`));
}
